import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { REPORT } from './components';

const routes = () => (
  <PrivateRoute exact path="/reporting/ivr-report" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/IVRReport/routes.js